/**
 * This file homes common query selectors. All query selectors should be written to be
 * easily concatenated with other queries, e.g. wrapped in `:is` if they contain commas.
 */
/** Query selector to get native dialogs or role dialog. */
const FLOATING_OVERLAY_QUERY = '[data-fpl-floating-overlay]';
/** Query selector to get native dialogs or role dialog. */
const DIALOG_QUERY = ':is(dialog,[role="dialog"])';
/** Query selector to get modal elements. */
const MODAL_QUERY = '[aria-modal="true"]';
/** Query selector for elements that act as grid or table cells. */
const CELL_QUERY = ':is(td,[role="gridcell"],[role="rowheader"])';
/** Query selector for elements that can act as the column header of a table or grid. */
const COLUMN_HEADER_QUERY = ':is(th,[role="columnheader"])';
/** Query selector for a role="option" element. */
const OPTION_QUERY = '[role=option]';
/** Elements can opt out of app focus and hold focus after being clicked. */
const HOLD_FOCUS_QUERY = '[data-hold-focus]';
/**
 * Query selector for ephemeral popup containers (menus, listboxes, floating overlays, aria-modal
 * surfaces, etc.) whose contents unmount when dismissed. Used to skip transient interactions like a
 * menu item when picking a durable focus-return fallback. Intentionally permissive: matches only
 * affect the fallback and the live element always wins when connected, so prefer over-inclusion.
 */
const EPHEMERAL_CONTAINER_QUERY = `:is([role="menu"],[role="listbox"],${FLOATING_OVERLAY_QUERY},${MODAL_QUERY})`;

export { CELL_QUERY, COLUMN_HEADER_QUERY, DIALOG_QUERY, EPHEMERAL_CONTAINER_QUERY, FLOATING_OVERLAY_QUERY, HOLD_FOCUS_QUERY, MODAL_QUERY, OPTION_QUERY };
//# sourceMappingURL=query.js.map
